export class ListaPagamentoDTO {
    pdfUnico: boolean = false;
    pagamentos: number[];
}
